import styled from 'styled-components';

export const InfoLabelStyled = styled.div`
  margin-top: 6px;
  display: inline-flex;
  font-weight: 500;
`;
